import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'antd';
import './style.scss';

const SettingsInfo = ({
  history, user, path, settingName, customStyle
}) => (
  <div className="settings-info-main-container" style={customStyle}>
    <Tooltip
      className="settings-info-tooltip"
      color="rgb(240, 240, 240)"
      title={(
        <span className="settings-info-tooltip-text">
          {user?.org_id ? (
            <React.Fragment>
              To modify this
              {' '}
              <span style={{ borderBottom: '1px solid rgb(45, 124, 246)' }}>{settingName}</span>
              {' '}
              setting please,
              {' '}
              <span
                className="settings-info-tooltip-link"
                onClick={(e) => {
                  e.stopPropagation(); // Prevents the tooltip from disappearing when clicking the link
                  history.push(path);
                }}
              >
                click here
              </span>
              .
            </React.Fragment>
          ) : 'You can modify this setting from admin configuration. But you did not have permission for switch to Admin. Please contact your admin.'}
        </span>
      )}
    >
      <span
        style={{
          fontSize: '12px',
          color: 'rgb(45, 124, 246)',
        }}
        className="settings-info-tooltip-icon"
      >
        <FontAwesomeIcon icon={faCircleInfo} />
      </span>
    </Tooltip>
  </div>
);

const mapStateToProps = ({
  UserReducers,
}) => ({
  user: UserReducers.user,
});

const mapDispatchToProps = (dispatch) => ({
});

SettingsInfo.propTypes = {
  user: PropTypes.object,
  history: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SettingsInfo));
